import { Injectable, signal } from '@angular/core';

/**
 * Shared service to control the visibility of the "Make a Payment" button
 * across components (e.g., navigation menu, current statement).
 *
 * The button should be hidden when DueAmount or BalanceDue is 0.
 */
@Injectable({ providedIn: 'root' })
export class MakePaymentVisibilityService {
  /** Whether the "Make a Payment" button should be shown. Defaults to true. */
  readonly showMakePayment = signal<boolean>(true);

  setVisibility(visible: boolean): void {
    this.showMakePayment.set(visible);
  }
}
